import Home from './Components/Home'
import Menu from './Components/Menu'
import {Route , Switch} from 'react-router-dom';
import { useState } from 'react';
import "./App.css"
import About from './Components/About/About';
import Social from './Components/Social';
import Portfolio from './Components/Portfolio/Portfolio';
import Contact from './Components/Contact/Contact';
import MetaTags from 'react-meta-tags';
import {NavLink} from 'react-router-dom';
import home from './Components/img/icons/home.png' 
import user from './Components/img/icons/user.png' 
import briefcase from './Components/img/icons/briefcase.png' 
import identification from './Components/img/icons/identification (1).png' 
function App() {

  const [menuShow, setmenuShow] = useState(false)

  const menuClick=()=>{
   console.log('clicked');
   setmenuShow(true);
   console.log(menuShow);
  }
  const linkClick=()=>{
    setmenuShow(false);
  }

  return (

    <Switch>
    <Route path="/" exact>
    <div class="New">
    <MetaTags>
        <title>Adarsh</title>
        <meta name="description" content="Some description." />
        <meta property="og:title" content="MyApp" />
        <meta property="og:image" content="path/to/image.jpg" />
      </MetaTags> 
      <div className='cherish'>
        <nav className="navie">
        {/* <ul>
            <li className="list"><a href="/"><img src={home} className="naviicon" alt="" /><NavLink to="/">HOME</NavLink></a></li>
            <li className="list"><a href="/about"><img src={user} className="naviicon"  alt="" /><NavLink to="/about">ABOUT</NavLink></a></li>
            <li className="list"><a href="/portfoio"><img src={briefcase} className="naviicon"  alt="" /><NavLink to="/portfoio">PORTFOLIO</NavLink></a></li>
            <li className="list"><a href="/contact"><img src={identification} className="naviicon"  alt="" /><NavLink to="/contact">CONTACT</NavLink></a></li>
          </ul> */}
        <div className="burger" onClick={menuClick}>
        <div className="line1"></div>
        <div className="line2"></div>
        <div className="line3"></div>
        </div>
        </nav>  
       {menuShow ? <div className='plane'>
        
       <div className="burgerSec" onClick={linkClick}>
        </div>
      
          <nav>
            {/* <ul> */}
              <li onClick={linkClick} className="list"><img src={home} className="naviicon" alt="" /><NavLink to="/">HOME</NavLink><a href=""></a></li>
              <li className="list"><img src={user} className="naviicon" alt="" /><NavLink to="/about">ABOUT</NavLink><a href=""></a></li>
              <li className="list"><img src={briefcase} className="naviicon" alt="" /><NavLink to="/portfoio">PORTFOLIO</NavLink><a href=""></a></li>
              <li className="list"><img src={identification} className="naviicon" alt="" /><NavLink to="/contact">CONTACT</NavLink><a href=""></a></li>
            {/* </ul> */}
          </nav>
        </div>: null}
      </div>
      
      <div className='section'> 
      <Home/>
      <div className='visible'>
      <Menu/>
      </div>
      <Social/>
      </div>
    </div>
    </Route>

    <Route path="/about" exact>
    <About Onclose ={linkClick}/>
    </Route>

    <Route path="/portfoio" exact>
    <Portfolio Onclose ={linkClick}/>
    </Route>

    <Route path="/contact" exact>
    <Contact Onclose ={linkClick}/>
    </Route>
    </Switch>
  );
}

export default App;
